export default "__VITE_ASSET__5043bd0d__"